if (!customElements.get('ac-countdown')) {
  customElements.define('ac-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      this.end = Date.parse(this.dataset.end);
      if (!Number.isFinite(this.end)) { this.hidden = true; return; }
      this.tick();
      if (!this.hidden) this.timer = setInterval(() => this.tick(), 1000);
    }
    tick() {
      const remaining = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      if (!remaining) { this.hidden = true; clearInterval(this.timer); return; }
      const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
      for (const [unit, number] of Object.entries(values)) { const node=this.querySelector(`[data-time="${unit}"]`); if(node) node.textContent=String(number).padStart(2,'0'); }
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
